import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import { usePaymentQuery } from '../../../api/usePaymentQuery';

export const AchSaved: React.FC = () => {
  const { data } = usePaymentQuery();

  if (!data) {
    return null;
  }

  const { maskedNumber } = data;

  return (
    <>
      <Box display="flex" alignItems="center" mb="16">
        <Text fontSize="h6" fontWeight={600}>
          Ach Info
        </Text>
      </Box>

      <Input
        label="Checking Account"
        value={maskedNumber || ''}
        disabled
        type="text"
        placeholder="Checking Account"
      />
    </>
  );
};
